(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pur-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var offer = document.querySelector('#pur-offer');
  var bar = document.querySelector('.pur-mobile-bar');
  if (!offer || !bar || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    var entry = entries[0];
    bar.dataset.active = !entry.isIntersecting && entry.boundingClientRect.bottom < 0 ? 'true' : 'false';
  }, { threshold: 0 });
  observer.observe(offer);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-article"]) return;
  try {
    
var purArticleUrl = new URL(window.location.href);
if (
  purArticleUrl.searchParams.get('customer_posted') === 'true' &&
  document.querySelector('.pur-article-capture')
) {
  purArticleUrl.searchParams.delete('customer_posted');
  window.history.replaceState({}, '', purArticleUrl.pathname + purArticleUrl.search + purArticleUrl.hash);
}

if (!document.documentElement.dataset.purArticleTrackingBound) {
  document.documentElement.dataset.purArticleTrackingBound = 'true';
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-pur-article-product]');
    if (!link) return;
    var eventData = {
      article_slug: link.dataset.articleSlug,
      page_path: window.location.pathname,
      link_url: link.href
    };
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'article_product_click', eventData);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'article_product_click' }, eventData));
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
